module.exports = __webpack_public_path__ + "static/media/PB_Y_13.d1927d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_13.png
// module id = 242
// module chunks = 0